import { FC } from 'react';
import { MediaType } from '@repo-level/core-front';

import { Responsive } from 'components/internal/Responsive';
import { Sidebar } from '../Sidebar';
import { TabBar } from '../Tabbar';

export const Nav: FC = () => (
  <Responsive
    desktopL={<Sidebar />}
    desktop={MediaType.DESKTOP_L}
    tablet={MediaType.DESKTOP_L}
    mobile={<TabBar />}
    mobileS={MediaType.MOBILE}
  />
);
